import { FormInitializerReturnType } from 'src/Configuration/validation'
import { WallboxConfigurationModel, WallboxPhaseType } from '../..'
import { EfyModel } from '../../models/wallbox-configuration/wallbox-configuration-settings-form.model'
import { useWallboxSettingsFormValidationFields } from '..'
import { object } from 'yup'
import { WallboxOcppModel } from '../../models'

const ALLOWED_NUMBER_PHASES: WallboxPhaseType[] = [1, 3]

/**
 * Initializes the form for editing wallbox efy settings
 * @param model WallboxConfigurationModel
 * @returns initialValues and validationSchema for wallbox efy settings form
 */
export const useWallboxEfyFormInitializer = (
  ocppSettings: WallboxOcppModel | null,
  model?: WallboxConfigurationModel
): FormInitializerReturnType<EfyModel, EfyModel> => {
  const validationFields = useWallboxSettingsFormValidationFields()

  const initialValues = {
    sunModeActive: model?.sunModeActive ?? false,
    numberPhases: model?.numberPhases ?? 1,
    maxChargeCurrent: model?.maxChargeCurrent ?? 0,
    minChargeCurrent: model?.minChargeCurrent ?? 0,
    upperCurrentLimit: model?.upperCurrentLimit ?? 0,
    chargeStopHysteresis: model?.chargeStopHysteresis ?? 0,
    dhcpEnabled: model?.dhcpEnabled ?? false,
    ipAddress: model?.ipAddr ?? '',
    subnetMask: model?.subnetMask ?? '',
    gateway: model?.gateway ?? '',
    keyLockMode: model?.keyLockMode,
    rfidReaderEnabled: model?.rfidReaderEnabled,
    authRequired: Boolean(model?.authRequired),
    ocppEnabled: ocppSettings?.enabled ?? false,
    ocppId: ocppSettings?.id ?? '',
    ocppServerAddress: ocppSettings?.serverAddress,
    ocppAuthType: ocppSettings?.authType,
    ocppAllowLocalCharge: ocppSettings?.allowLocalCharge,
    ocppPassword: ocppSettings?.password ?? '',
  }

  const validationSchema = object().shape({
    sunModeActive: validationFields.sunModeActiveField(),
    numberPhases: validationFields.numberPhasesField(ALLOWED_NUMBER_PHASES),
    maxChargeCurrent: validationFields.maxChargeCurrentField(),
    upperCurrentLimit: validationFields.upperCurrentLimitField(),
    minChargeCurrent: validationFields.minChargeCurrentField(),
    chargeStopHysteresis: validationFields.chargeStopHysteresisField(),
    dhcpEnabled: validationFields.dhcpEnabledField(),
    ipAddress: validationFields.ipAddressField(),
    subnetMask: validationFields.subnetMaskField(),
    gateway: validationFields.gatewayField(),
    rfidReaderEnabled: validationFields.rfidReaderEnabledField(),
    authRequired: validationFields.authRequiredField(),
    ocppEnabled: validationFields.ocppEnabledField(),
    ocppId: validationFields.ocppIdField(),
    ocppServerAddress: validationFields.ocppServerAddressField(),
    ocppAuthType: validationFields.ocppAuthTypeField(),
    ocppAllowLocalCharge: validationFields.ocppAllowLocalChargeField(),
    ocppPassword: validationFields.ocppPasswordField(),
  })
  return { initialValues, validationSchema }
}
